import { enableProdMode } from '@angular/core'
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic'
import { registerLicense } from '@syncfusion/ej2-base'

import { AppModule } from './app/app.module'
import { environment } from './environments/environment'

const shouldNormalizeLocalPreviewHost =
  window.location.hostname === '127.0.0.1' && /^42\d\d$/.test(window.location.port)

if (shouldNormalizeLocalPreviewHost) {
  window.location.replace(
    `http://localhost:${window.location.port}${window.location.pathname}${window.location.search}${window.location.hash}`
  )
} else {
  // Register Syncfusion license before Angular bootstraps.
  // Syncfusion components are only used in lazy-loaded OEEDashboardModule,
  // so this runs well before any Syncfusion code loads.
  registerLicense(environment.syncfusionLicenseKey)

  // Also try window global as backup (set in index.html)
  if ((window as any).sfLicenseKey) {
    registerLicense((window as any).sfLicenseKey)
  }

  const envWindow = window as any
  envWindow['env'] = envWindow['env'] || {}
  envWindow['env']['shouldIndex'] = environment.production

  if (environment.production) {
    enableProdMode()

    // Suppress console.log/debug in production unless ?debug=true is in the URL
    const debugEnabled = window.location.search.includes('debug=true')
    if (!debugEnabled) {
      console.log = () => {}
      console.debug = () => {}
    }
  }

  platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(err => console.error(err))
}
